import { useSuspenseQuery } from "@tanstack/react-query";
import api from "apis";

const useMyProfileDetailQuery = () => {
  return useSuspenseQuery({
    queryKey: api.user.getUserDetailKey(),
    queryFn: api.user.getUserDetail,
  });
};

export default useMyProfileDetailQuery;
